
<ng-container [formGroup]="textFormGroup">
  <mat-form-field class='field-filter' appearance='outline'>
    <mat-label>{{data.place_holder}}</mat-label>
    <input matInput name="{{data.options.key}}" formControlName='{{data.options.key}}'/>
  </mat-form-field>
</ng-container>
